import { fetchPost } from '../Service/ApiService'

export const activeApplicants = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`usercouponbuy/bulckapprove`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};







